import ApiService from "../../ApiService";
import AppConfig from "../../../config/AppConfig";

const PracticeResultService = {
    loadScreenView: (inVO, successCallback, failureCallback) => {
        ApiService.post("/mobile/talkchinese/practiceresult/loadscreenview", { inVO }, successCallback, failureCallback);
    },
    updateUnitResult: (unitResult, successCallback, failureCallback) => {
        let formData = new FormData();
        formData.append("clientType", 1);
        formData.append("clientVersion", AppConfig.APP_CLIENT_VERSION);
        formData.append("clientBuild", AppConfig.APP_CLIENT_BUILD);
        formData.append("unitResult", unitResult);

        ApiService.post("/mobile/talkchinese/practiceresult/updateunitresult", formData, successCallback, failureCallback);
    },
};

export default PracticeResultService;
